import UspSection from './UspSection';

export default UspSection;
